import { HostListResponse } from './flagr';

const stqConfig: HostListResponse = {
  version: 0,
  leyanbot: [
    {
      domain: import.meta.env.VITE_LEYANBOT_HOST as string,
    },
  ],
  flagr: [
    {
      domain: import.meta.env.VITE_FLAGR_ENDPOINT as string,
    },
  ],
};

const prqConfig: HostListResponse = {
  version: 0,
  leyanbot: [
    {
      domain: import.meta.env.VITE_LEYANBOT_HOST as string,
    },
    {
      domain: 'https://api.jolect.com/prq',
    },
    {
      domain: 'https://sgo-api.jolect.com/prq',
    },
    {
      domain: 'https://usq-api.jolect.com/prq',
    },
  ],
  flagr: [
    {
      domain: import.meta.env.VITE_FLAGR_ENDPOINT as string,
    },
    {
      domain: 'https://api.jolect.com/nta',
    },
    {
      domain: 'https://sgo-api.jolect.com/nta',
    },
  ],
};

export const defaultHostList = import.meta.env.VITE_NIM_ENV === 'prq' ? prqConfig : stqConfig;
